/** Default sidebar widths (pixels); persisted widths clamp to min/max. */
export const DEFAULT_LEFT_PANEL_WIDTH = 280;
export const DEFAULT_RIGHT_PANEL_WIDTH = 380;

export const LEFT_PANEL_MIN = 220;
export const LEFT_PANEL_MAX = 480;
export const RIGHT_PANEL_MIN = 280;
export const RIGHT_PANEL_MAX = 620;

export const SASH_WIDTH_PX = 6;
export const COLLAPSED_RAIL_WIDTH_PX = 44;
export const ACTIVITY_BAR_WIDTH_PX = 44;

export function clampLeftWidth(value: number): number {
  return Math.max(LEFT_PANEL_MIN, Math.min(LEFT_PANEL_MAX, value));
}

export function clampRightWidth(value: number): number {
  return Math.max(RIGHT_PANEL_MIN, Math.min(RIGHT_PANEL_MAX, value));
}
